import React from 'react';
import { IonContent, IonPage } from '@ionic/react';
import { useParams } from 'react-router';

export default function GuestSharingSuccessPage() {
    const { type, id } = useParams();

    return (
        <IonPage>
            <IonContent>
                <section id="whatsapp-success-page" className="relative pt-8 pb-32 font-sans text-center">
                    <div className="px-8">
                        <h2 className="font-bold text-4xl">Condivisione completata!</h2>
                        <p className="mt-8">Attendi che il proprietario effettui l'ordine.</p>
                    </div>
                    <img src="/assets/images/checkout_success.png" className="w-1/2 m-auto pt-12" alt="checkout success" />

                    <div className="fixed bottom-0 w-full flex flex-col justify-center mt-8 px-4 py-6 bg-white">
                        <a href={`/${type}/q/${id}/menu`} className="block py-2 rounded-full bg-mycia-green">TORNA AL MENU</a>
                    </div>
                </section>
            </IonContent>
        </IonPage>
    )
}
